import React, { useContext } from "react";
import {
  Row,
  IconWrapper,
  HorizontalSeparator,
  IconBox,
  TextWrapper2,
  Text,
} from "../styled/Tooltip.styled";
import { formatSupplyLevel, SupplyType } from "../../constants/WebMap";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";


const needsPercentage = (label) => {
  return ['Buildup', 'Dense Urban', 'Rural', 'Suburban', 'Urban'].includes(label);
};


const formatValue = (value, label) => {
  if (typeof value === 'number') {
    if (needsPercentage(label)) {
      return `${value.toFixed(2)} %`;
    } else {
      return value.toLocaleString('en-US');
    }
  }
  return value;
};

const imageMap = {
  "Total Roads": "/assets/Total Roads.png",
  "Roads Length": "/assets/Roads Length.png",
  "Population": "/assets/Population1.png",
  "Buildup": "/assets/Buildup.png",
  "POI": "/assets/POI.png",
  "Dense Urban": "/assets/Dense Urban.png",
  "Urban": "/assets/Urban.png",
  "Suburban": "/assets/Suburban.png",
  "Rural": "/assets/Rural.png"
};




const DataRow = ({ label, value, topMarketShareToggle }) => {
  const marginValue = topMarketShareToggle ? '5px' : '10px';
  return (
    <Row style={{ marginTop: marginValue, marginBottom: marginValue }}>
      <div style={{ display: "flex", alignItems: "center", margin: "1px 0px" }}>
        <img src={imageMap[label] || "/assets/default.png"} alt="logo" style={{ width: "13px", marginRight: "8px" }} />
        <Text>{label}</Text>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: '80px',
        }}
      >
        <TextWrapper2 isBold={false} >
          {value ? formatValue(value, label) : "No Data"}
        </TextWrapper2>
      </div>
    </Row>
  );
};

export default function InfoTooltipInternal({ data, topMarketShareToggle }) {
  return (
    <div>
      <DataRow label="Total Roads" value={data.tot_count} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Roads Length" value={`${data?.tot_length?.toLocaleString('en-US')} m`} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Population" value={data.pop} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Buildup" value={data.build_up} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="POI" value={data.tot_poi} topMarketShareToggle={topMarketShareToggle} />
      <HorizontalSeparator />
      <DataRow label="Dense Urban" value={data.d_urban} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Urban" value={data.urban} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Suburban" value={data.s_urban} topMarketShareToggle={topMarketShareToggle} />
      <DataRow label="Rural" value={data.rural} topMarketShareToggle={topMarketShareToggle} />
    </div>
  );
}
